// src/redux/customer/selectors.ts
import { RootState } from '@/redux/store';

export const selectReceiptsState = (s: RootState) =>
  s.customer.payments?.receipts;

export const selectReceipts = (s: RootState) =>
  s.customer.payments?.receipts?.data ?? [];

export const selectReceiptsMeta = (s: RootState) => {
  const st = s.customer.payments?.receipts;
  return {
    count: st?.count ?? 0,
    next: st?.next ?? null,
    previous: st?.previous ?? null,
    loading: st?.loading ?? false,
    error: st?.error ?? null,
    downloadLoading: st?.downloadLoading ?? false,
    downloadError: st?.downloadError ?? null,
  };
};

export const selectInvoicesState = (s: RootState) =>
  s.customer.payments?.invoices;

export const selectInvoices = (s: RootState) =>
  s.customer.payments?.invoices?.data ?? [];

export const selectInvoicesMeta = (s: RootState) => {
  const st = s.customer.payments?.invoices;
  return {
    count: st?.count ?? 0,
    next: st?.next ?? null,
    previous: st?.previous ?? null,
    loading: st?.loading ?? false,
    error: st?.error ?? null,
    downloadLoading: st?.downloadLoading ?? false,
    downloadError: st?.downloadError ?? null,
  };
};

export const selectPaymentsStatus = (s: RootState) =>
  s.customer.payments?.status?.data;

export const selectPaymentsStatusMeta = (s: RootState) => ({
  loading: s.customer.payments?.status?.loading ?? false,
  error: s.customer.payments?.status?.error ?? null,
});

export const selectApplicationsState = (s: RootState) =>
  s.customer.workflows?.applications;

export const selectAuthorizationsState = (s: RootState) =>
  s.customer.workflows?.authorizations;

export const selectNotificationsState = (s: RootState) =>
  s.customer.workflows?.notifications;

export const selectOutstandingBalanceState = (s: RootState) =>
  s.customer.outstandingBalance;